<template>
    <app-layout title="My Documents">
        <template #header>
            <h2 class="font-semibold text-xl text-white leading-tight">
                My Documents
            </h2>
        </template>

        <div class="py-6">
            <div class="max-w-5xl mx-auto sm:px-6 lg:px-8 space-y-6">
                <div v-if="properties.length === 0" class="bg-white rounded-lg shadow p-10 text-center">
                    <font-awesome-icon :icon="faFolderOpen" class="text-4xl text-gray-300 mb-3" />
                    <h3 class="text-lg font-medium text-gray-800">No documents have been shared with you yet</h3>
                    <p class="text-sm text-gray-500 mt-1">
                        When your landlord shares a document, it will show up here.
                    </p>
                </div>

                <div
                    v-for="group in properties"
                    :key="group.property_id"
                    class="bg-white rounded-lg shadow overflow-hidden"
                >
                    <div class="px-6 py-4 border-b border-gray-100">
                        <h3 class="text-base font-semibold text-gray-800">
                            {{ group.address || 'Property' }}
                        </h3>
                        <p v-if="group.agent" class="text-xs text-gray-500 mt-0.5">
                            Shared by {{ group.agent.name }} ({{ group.agent.email }})
                        </p>
                    </div>

                    <ul class="divide-y divide-gray-100">
                        <li
                            v-for="doc in group.documents"
                            :key="doc.id"
                            class="px-6 py-4 flex items-center justify-between hover:bg-gray-50"
                        >
                            <div class="flex items-center gap-3 min-w-0">
                                <div class="flex-shrink-0 w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                                    <font-awesome-icon :icon="faFileLines" class="text-purple-600" />
                                </div>
                                <div class="min-w-0">
                                    <button
                                        type="button"
                                        @click="downloadDocument(doc)"
                                        class="text-sm font-medium text-purple-700 hover:text-purple-900 underline truncate text-left"
                                    >
                                        {{ doc.title || doc.file_name }}
                                    </button>
                                    <p v-if="doc.title" class="text-xs text-gray-500 truncate">{{ doc.file_name }}</p>
                                    <p class="text-xs text-gray-400 mt-0.5">Uploaded {{ doc.uploaded_at }}</p>
                                </div>
                            </div>
                            <button
                                type="button"
                                @click="downloadDocument(doc)"
                                class="text-xs text-gray-600 hover:text-purple-700 font-medium px-3 py-1.5 border border-gray-300 rounded-md hover:border-purple-300 transition-colors whitespace-nowrap"
                            >
                                Download
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFolderOpen, faFileLines } from '@fortawesome/pro-light-svg-icons'

defineProps({
    properties: { type: Array, default: () => [] },
})

const downloadDocument = async (doc) => {
    try {
        const { data } = await axios.get(`/documents/${doc.id}/download`)
        if (data?.url) window.open(data.url, '_blank')
    } catch (error) {
        alert(error.response?.data?.message || 'Failed to generate download link.')
    }
}
</script>
